import { Route, RouteObject } from "react-router-dom";
import { uxHistoryRoutes } from "./history";
import { uxMessagingRoutes } from "./messaging";
import { uxListsRoutes } from "./lists";

import { workflowsSetupRoutes } from "./work-flow/routes";
import { templatesSetupRoutes } from "./templates/routes";
import { dashboardSetupRoutes } from "./dashboard";
import { uxSettingsRoutes } from "./components/settings/routes";
import { uxMessageActivityRoutes } from "./components/messageActivity/routes";
import { uxTemplatesRoutes } from "./components/templates/routes";
import { uxRecipientListRoutes } from "./components/recipientList/routes";
import { uxQuickMessageRoutes } from "./components/quickMessage/routes";
import { uxWorkflowRoutes } from "./components/workflow/routes";

export interface uxRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxRoute[];
}

export const uxRoutes: uxRoute[] = [
  ...uxHistoryRoutes,
  ...uxMessagingRoutes,
  ...uxListsRoutes,
  ...dashboardSetupRoutes,
  ...workflowsSetupRoutes,
  ...templatesSetupRoutes,

  ...uxSettingsRoutes,
  ...uxMessageActivityRoutes,
  ...uxTemplatesRoutes,
  ...uxRecipientListRoutes,
  ...uxQuickMessageRoutes,
  ...uxWorkflowRoutes,
];
